/* eslint-disable @typescript-eslint/camelcase */
import '@/scripts/legacy-ui-library/toolkit';
import '@/scripts/legacy-ui-library/player';

import _ from 'underscore';
import { Model, Helper } from '@viddsee/server-api-client';

import AcHelper from '@/scripts/helpers/ac-helper';
import { initializeAutoTracker } from '@/scripts/libs/analytic/common-autotrack';
import loginController from '@/scripts/libs/login/controller';
import embedPlayer from '@/scripts/libs/player/embed';
import { VideoPagePlayerOptions } from '@/scripts/models/VideoPagePlayerOptions';
import { addPscTracker } from '@/scripts/pages/video/VideoTrackers/Psct/pscTrackerDomInjector';

initializeAutoTracker();
$(() => {
  _.templateSettings = {
    interpolate: /\{\{=(.+?)\}\}/g,
    evaluate: /\{\{(.+?)\}\}/g,
  };

  // Do you even init?
  loginController.init();

  loginController.getUser().then((user): void => {
    if (!user) return;
    // window.OneSignal = window.OneSignal || [];
    // if (typeof window.OneSignal !== 'undefined' && window.OneSignal.push) {
    //   window.OneSignal.push(() => {
    //     window.OneSignal.sendTags({ user_id: localStorage.getItem('user_id'), supports_points_system: 'true' });
    //   });
    // }
    window.snowplow('setUserId', `${user.id}`);
  });

  // Gather necessary information needed to initialize video player
  const ssrData = (window as any).__ssr__data__.data as { video: any; playerOptions: VideoPagePlayerOptions } | {};

  if (!('video' in ssrData)) {
    return;
  };

  const { video: videoResponse, playerOptions } = ssrData;
  const video: Model.Video.Info = Helper.convertToCamelCase(videoResponse);

  // Initialize video player
  embedPlayer.init(
    {
      page_token: playerOptions.page_token,
      player_type: playerOptions.player_type,
      service_type: playerOptions.service_type,
      parent_url: AcHelper.getParentUrl() || '',

      country_code: playerOptions.country_code,
    } as VideoPagePlayerOptions,
    video,
  );

  const _shareFB = function _shareFB(): void {
    const videoUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    switch (AcHelper.checkBrowser()) {
      case 'ie7':
      case 'ie8':
      case 'ie9':
        window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(videoUrl) +
          '&pubid=ra-54bc7e9f113747fd&ct=1',
        );
        break;
      case 'ff':
      case 'ie10':
      case 'chrome':
      default:
        window.open((
          'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(videoUrl) +
          '&pubid=ra-54bc7e9f113747fd&ct=1'
        ),
        'facebook-share-dialog',
        'width=626,height=436',
        );
        break;
    }
  };

  const _shareTW = function _shareTW(e: JQueryEventObject): void {
    const videoUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    const tweet = $(e.target).data('tweet');

    const windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
    const width = 550;
    const height = 420;
    const winHeight = screen.height;
    const winWidth = screen.width;

    const left = Math.round((winWidth / 2) - (width / 2));
    let top = 0;
    if (winHeight > height) {
      top = Math.round((winHeight / 2) - (height / 2));
    }

    const encodedTweet = encodeURIComponent(tweet);
    const url = (
      'https://twitter.com/intent/tweet?text=' +
      encodedTweet +
      '&url=' +
      encodeURIComponent(videoUrl) +
      '&pubid=ra-54bc7e9f113747fd&ct=1' +
      '&via=viddsee'
    );
    window.open(url, 'intent',
      windowOptions + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);
  };

  const _shareEmail = function _shareEmail(e: JQueryEventObject): void {
    const videoUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    const subject = $(e.target).data('subject');
    const body = [];
    body.push($(e.target).data('body0'));
    body.push($(e.target).data('body1'));

    window.location.href = (
      'mailto:?subject=' +
      encodeURIComponent(subject) +
      '&body=' +
      encodeURIComponent(body[Math.floor(Math.random() * body.length)]) +
      '%0A' +
      encodeURIComponent(videoUrl)
    );
  };

  // Action Bar - Share
  $('.video__object__player__overlay--share__content').on('click', '.js-video__share__facebook, .js-video__share__twitter, .js-video__share__email', (e) => {
    const $target = $(e.target);
    switch ($target.data('type')) {
      case 'facebook':
        _shareFB();
        break;
      case 'twitter':
        _shareTW(e);
        break;
      case 'email':
        _shareEmail(e);
        break;
      default: break;
    }
  });

  (async(): Promise<void> => {
    const player = await embedPlayer.getJwplayerObject() as jwplayer.JWPlayer;
    addPscTracker(
      video,
      player,
    );
  })();
});
